import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import ProtectRoute from "../utils/components/ProtectRoute/ProtectRoute";
import useRoutes from "../routes/useRoutes";

const Index = () => {
  const navigate = useNavigate();
  const {
    allowedUserComponent,
  } = useRoutes();


  useEffect(() => {
    if (!localStorage.getItem("USER_ACCESS_TOKEN")) {
      navigate("/login");
    } else {
      if (allowedUserComponent?.length > 0) {
        navigate(
          `/${allowedUserComponent?.map((item) => item?.path)?.[0]}`
        );
      }
    }
    // eslint-disable-next-line
  }, [allowedUserComponent]);

  return (
    <ProtectRoute>
      <Outlet />
    </ProtectRoute>
  );
};

export default Index;
